import React from 'react';

const CancellationRefunds = () => {
  return (
    <div className="policy-page">
      <h1>Cancellation & Refunds Policy</h1>
      <p>
        ClevSheetsAI is a digital subscription service. You may cancel your subscription at any time by contacting our support.
        If you cancel within 14 days of subscribing, you may be eligible for a full refund. After this period, refunds will be prorated based on the unused portion of your subscription or may not be available.
      </p>
      <p>
        For cancellation and refund requests, please contact us at{" "}
        <a href="mailto:clevsheetsai@gmail.com">clevsheetsai@gmail.com</a>.
      </p>
    </div>
  );
};

export default CancellationRefunds;
